import React from "react";
import "./ComponentCard.css";
import CatalogAssets from "./CatalogAssets";

export default function ComponentCard({
    component,
    onRefresh,
    refreshLoading
}) {
    if (!component) return null;

    return (
        <div className="card">

            {/* ================= HEADER ================= */}
            <div className="header">

                {/* Левая часть: название + производитель */}
                <div className="titleBox">
                    <h2 className="partNumber">{component.part_number}</h2>
                    {component.manufacturer && (
                        <div className="manufacturer">{component.manufacturer}</div>
                    )}
                </div>

                {/* Правая часть: кнопка обновить + бейджи */}
                <div className="headerRight">

                    {/* КНОПКА ОБНОВИТЬ */}
                    {onRefresh && (
                        <button
                            className="refreshButton"
                            onClick={onRefresh}
                            disabled={refreshLoading}
                            title="Обновить данные компонента"
                        >
                            {refreshLoading ? "⏳" : "🔄"}
                        </button>
                    )}

                    {/* БЕЙДЖИ */}
                    <div className="badges">
                        {component.category && (
                            <span className="badgeCategory">
                                {component.category}
                            </span>
                        )}

                        {component.active_c && (
                            <span
                                className={
                                    component.active_c.toLowerCase() === "активный"
                                        ? "badgeActive"
                                        : "badgePassive"
                                }
                            >
                                {component.active_c.toLowerCase() === "активный"
                                    ? "Активный"
                                    : "Пассивный"}
                            </span>
                        )}
                    </div>

                </div>
            </div>

            <CatalogAssets key={component.part_number} partNumber={component.part_number} />

            {/* ================= DESCRIPTION ================= */}
            {component.description && (
                <p className="description">{component.description}</p>
            )}

            {/* ================= MAIN INFO ================= */}
            <section className="section">
                <h3>Основная информация</h3>
                <div className="grid">
                    <Field label="Тип" value={component.type} />
                    <Field label="Технология" value={component.technology} />
                    <Field label="Статус" value={component.status} />
                </div>
            </section>

            {/* ================= SPECIFICATIONS ================= */}
            {component.specifications && (
                <section className="section">
                    <h3>Характеристики</h3>

                    <div className="specList">
                        {Object.entries({
                            ...component.specifications,
                            ...(component.weight ? { weight: component.weight } : {}),
                            ...(component.encryption ? { encryption: component.encryption } : {}),
                        }).map(([key, value]) => (
                            <div key={key} className="specItem">
                                <span className="specKey">{key}</span>
                                <span className="specValue">{String(value)}</span>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {/* ================= FEATURES ================= */}
            {component.features && component.features.length > 0 && (
                <section className="section">
                    <h3>Особенности</h3>
                    <ul className="list">
                        {component.features.map((f, i) => (
                            <li key={i}>{f}</li>
                        ))}
                    </ul>
                </section>
            )}

            {/* ================= APPLICATIONS ================= */}
            {component.applications && component.applications.length > 0 && (
                <section className="section">
                    <h3>Применение</h3>
                    <ul className="list">
                        {component.applications.map((a, i) => (
                            <li key={i}>{a}</li>
                        ))}
                    </ul>
                </section>
            )}

            {/* ================= ALTERNATIVES ================= */}
            {component.alternatives && component.alternatives.length > 0 && (
                <section className="section">
                    <h3>Аналоги</h3>
                    <div className="altWrap">
                        {component.alternatives.map((alt, i) => (
                            <span key={i} className="altItem">
                                🔁 {alt}
                            </span>
                        ))}
                    </div>
                </section>
            )}
        </div>
    );
}

/* ================= FIELD ================= */
function Field({ label, value }) {
    if (!value) return null;

    return (
        <div className="field">
            <span className="label">{label}:</span>
            <span className="value">{value}</span>
        </div>
    );
}
